let i18nInstance;export function setI18n(instance){i18nInstance=instance}export function getI18n(){return i18nInstance}